export default "__VITE_ASSET__6a31ff9d__"